import SvgIcon from '@mui/material/SvgIcon';

const ProfileCustomClearIcon = (props) => {
    return (
      <SvgIcon {...props} viewBox="0 0 24 24">
        <path d="M13.89 8.7 12 10.59 10.11 8.7a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41L10.59 12 8.7 13.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l1.89 1.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l1.89-1.89c.39-.39.39-1.02 0-1.41-.39-.38-1.03-.38-1.41 0"/>
      </SvgIcon>
    );
  }
  export default ProfileCustomClearIcon;
